export default __webpack_public_path__ + "re_landuselv2-800-8a39ba8f4bc9dd043f672952ed12e682.webp";